import React, { useState } from "react";
import SliderPanel from "./../../components/SliderPanel/SliderPanel";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { DragDropContext } from "react-beautiful-dnd";
import {
  CensusAndPayroll,
  Census,
  Payroll,
  fileMetaData,
  mapperFormFields,
  parameterTypes,
} from "../../utils";
import { isNull, isEqual, get } from "lodash-es";
import TargetSection from "../../containers/Mapper/MapAndTransformOutput/TargetSection";
import TargetValueSection from "../../containers/Mapper/MapAndTransformOutput/TargetValueSection";
import {
  fileNameTypes,
  jsonToStringConverter,
  manageMapperFormNames,
  stringToJsonConverter,
} from "../../utils/constants/mapper";
import MappedFieldSetup from "../../containers/Mapper/MapAndTransformOutput/MappedFieldSetup";
import PreviewSection from "../../containers/Mapper/MapAndTransformOutput/PreviewSection";
import PreviewSectionForConfigureOutput from "../../containers/Mapper/MapAndTransformOutput/PreviewSectionForConfigureOutput";

const RuleFunctionsComponent = ({
  values,
  keyValue,
  setKey,
  errors,
  setClickToSelect,
  setFieldArrayName,
  disabledKeys,
  setDisabledKeys,
  index,
  hasHeader,
  fieldIndex,
  showField = true,
  headerError,
  valueError,
}) => {
  const [validationError, setValidationError] = useState(false);
  const showSource = false;
  const formName = manageMapperFormNames.MAP_AND_TRANSFORM_OUTPUT;
  const fields = mapperFormFields[formName];

  const onFormSubmit = (values) => {
    const value = jsonToStringConverter(values?.valueData);
    if (
      values?.valueData.value == null ||
      (values?.valueData.parameterType == 2 &&
        (value.includes("null") || value.includes("undefined")))
    )
      setValidationError(true);
    // else {
    //   setFieldValuesParent("fileName", value);
    //   setSlideShow(false);
    //   setValidationError(false);
    // }
  };
  return (
    <>
      <div className="ml-3" style={{ display: "flex" }}>
        <div>Header</div>
      </div>
      <div className="horizontalLineFieldSetup"></div>
      <div style={{ display: "flex" }}>
        <div
          style={{ width: "100%", marginLeft: showSource ? "300px" : "0px" }}
        >
          <TargetValueSection
            fields={fields}
            setKey={setKey}
            setClickToSelect={setClickToSelect}
            setFieldArrayName={setFieldArrayName}
            parameterTypes={showField ? parameterTypes : fileNameTypes}
            headerError={headerError}
            valueError={valueError}
          />
        </div>

        <PreviewSectionForConfigureOutput
          values={values}
          fields={fields}
          showSource={showSource}
        />
      </div>
    </>
  );
};

export default RuleFunctionsComponent;
